import type { BigWinTuning } from "@slot/game-shell";

// Per-game BIG-WIN overlay tuning VALUES (client presentation timing) — the ONLY file to edit to
// retune the big-win overlay. Shape is shell-side (BigWinTuning); the whole object is passed
// into BigWinPresenter (wired in createPresentation).
//
// The tier BREAKPOINTS (which win/bet multiplier reaches which tier) are NOT here — they are
// server-authoritative + universal, delivered via initialSettings.bigWinTiers.

export type { BigWinTuning };

export const BIG_WIN_TUNING: BigWinTuning = {
  autoCloseTimeoutMs: 5000,
  niceAutoCloseMs: 1200,
  // Tier titles: false = progressive escalation (reveal each as the amount climbs);
  // true = show the final tier's title + angels instantly at open (number still counts up).
  instantTierReveal: false,
  // Nice (lowest) tier = dimmed number only, no title/angels.
  niceTierNumberOnly: true,
  countUp: {
    // Slower, more dramatic count-up: duration = baseSeconds + digits·perDigitSeconds, capped.
    // e.g. a 5-digit win (12000) ≈ 1.8 + 5·0.6 = 4.8s; capped at 8s; floored at 150ms.
    baseSeconds: 1.8,
    perDigitSeconds: 0.6,
    maxSeconds: 8.0,
    minMs: 150,
    // Scroll starts SLOW then accelerates toward the end. Quad (2) is the gentle version;
    // bump easingExponent to 3 for a steeper slow→fast build.
    easing: "easeIn",
    easingExponent: 2,
  },
};
